const apiEndpoint = '/api/2023-01/graphql.json';
let customerAccessToken = window.customerData?.accessToken;

async function updateWishlist(productId, action) {

  if (!customerAccessToken) {
    window.location.href = "/account/login";
    return;
  }

  // Fetch the current wishlist
  const wishlistResponse = await fetch(apiEndpoint, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': window.customerData.token
  },
  body: JSON.stringify({
    query: `
      query getWishlist($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
          id
          metafield(namespace: "wishlist", key: "product_ids") {
            id
            value
            namespace
            key
          }
        }
      }
    `,
    variables: { customerAccessToken: window.customerData.accessToken }
  })
});


  const wishlistData = await wishlistResponse.json();
  console.log(wishlistData);
  const wishlist = wishlistData.data.customer.metafields.edges[0]?.node.value || '';
  let updatedWishlist = wishlist.split(',');

  if (action === 'add' && !updatedWishlist.includes(productId)) {
    updatedWishlist.push(productId);
  } else if (action === 'remove') {
    updatedWishlist = updatedWishlist.filter(id => id !== productId);
  }

  // Update wishlist metafield
  const updateResponse = await fetch(apiEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.customerData.token
    },
    body: JSON.stringify({
      query: `
        mutation updateWishlist($customerId: ID!, $updatedValue: String!) {
          customer(id: $customerId) {
            metafield(namespace: "wishlist", key: "product_ids") {
              value
              setValue(value: $updatedValue) {
                metafield {
                  value
                }
              }
            }
          }
        }
      `,
      variables: {
        customerId,
        updatedValue: updatedWishlist.join(',')
      }
    })
  });

  const updateData = await updateResponse.json();
  if (updateData.errors) {
    console.error('Error updating wishlist:', updateData.errors);
  } else {
    console.log('Wishlist updated successfully!');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const addToWishlistBtns = document.querySelectorAll('.add-to-wishlist');
  const removeFromWishlistBtns = document.querySelectorAll('.remove-from-wishlist');

  addToWishlistBtns.forEach((button) => {
    button.addEventListener('click', (event) => {
      // Prevent the form submission
      event.preventDefault();

      // Get the product ID from the button's data attribute
      const productId = event.target.getAttribute('data-product-id');

      // Call the updateWishlist function to handle the wishlist logic
      updateWishlist(productId, 'add');
    });
  });

  removeFromWishlistBtns.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const productId = event.target.getAttribute('data-product-id');
      updateWishlist(productId, 'remove');
    });
  });

  // Fetch wishlist data on page load for the account page
  if (window.location.pathname === '/account/wishlist') {
    fetchWishlistData();
  }
});

async function fetchWishlistData() {
  // Fetch current wishlist data and display it on the wishlist page
  const response = await fetch(apiEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.customerData.token
    },
    body: JSON.stringify({
      query: `
        query getWishlist($customerId: ID!) {
          customer(id: $customerId) {
            metafields(namespace: "wishlist", first: 1) {
              edges {
                node {
                  value
                }
              }
            }
          }
        }
      `,
      variables: { customerId }
    })
  });
  const wishlistData = await response.json();
  const productIds = wishlistData.data.customer.metafields.edges[0]?.node.value.split(',') || [];

  // Display products based on fetched data...
  console.log('Fetched wishlist products:', productIds);
}
